import * as React from "react";
const SvgWorkflow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-17.8080,6.08829) scale(0.046875)" }, /* @__PURE__ */ React.createElement("path", { d: "m 634.95062,-97.807163 c -8.92671,0 -17.8545,3.418519 -24.69475,10.258786 l -71.22658,71.226345 25.24726,25.2472345 60.7976,-60.7973805 c 2.73709,-2.737124 6.30586,-4.10273 9.87647,-4.10273 3.5708,0 7.1407,1.366519 9.87667,4.10273 L 692.3514,-4.3480664 666.65757,21.34622 h 76.70372 v -76.707316 l -25.76221,25.765802 -57.95351,-57.953083 c -6.84023,-6.840267 -15.76785,-10.258786 -24.69495,-10.258786 z M 453.92222,15.776774 479.68801,41.53917 421.7345,99.492456 c -6.84026,6.840254 -10.25835,15.767844 -10.25835,24.694974 0,8.92669 3.41809,17.8545 10.25835,24.69474 l 71.22679,71.22658 25.24724,-25.24724 -60.7974,-60.79763 c -2.7371,-2.7371 -4.10273,-6.30587 -4.10273,-9.87645 0,-3.5708 1.36653,-7.14071 4.10273,-9.87667 l 47.52413,-47.524127 25.69428,25.694071 v -76.70393 z m 321.53787,13.969205 -25.24726,25.247238 60.79765,60.797623 c 2.73708,2.73709 4.10245,6.30586 4.10245,9.87645 0,3.57103 -1.36649,7.14072 -4.10245,9.87668 l -47.52437,47.52412 -25.69428,-25.69407 v 76.70393 h 76.70752 l -25.766,-25.76239 57.95329,-57.9533 c 6.84049,-6.84025 10.25858,-15.76783 10.25858,-24.69497 0,-8.92668 -3.41809,-17.8545 -10.25858,-24.69475 z m -250.4,198.762521 v 76.70733 l 25.76239,-25.76579 57.95329,57.95351 c 6.84024,6.84026 15.76784,10.25835 24.69498,10.25835 8.92669,0 17.8545,-3.41809 24.69475,-10.25835 l 71.22656,-71.22679 -25.24723,-25.24724 -60.79765,60.79764 c -2.73708,2.73709 -6.30586,4.10247 -9.87643,4.10247 -3.57102,0 -7.14073,-1.36652 -9.87666,-4.10247 l -47.52414,-47.52437 25.69409,-25.69429 z", style: {
  color: "#000000",
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  fill: "#033d5d",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 45.3993,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
} })));
export default SvgWorkflow;
